import { runInAction } from "mobx";
import CalendarStore from "./calendarStore";
import { ClientTimeSlot } from "../../molecules/Calendar/controller/adapters/types";
import { navigateWithProjection } from "../../helpers/searchParams/navigateWithProjection";
import type { NavigateFunction } from "react-router-dom";

export type CalendarCommandsType = {
  onEventContentClick: (event: ClientTimeSlot) => Promise<void>;
  navigateToCalendar: (navigate: NavigateFunction, opts?: { date?: string; patientId?: number; patientLastName?: string; rxId?: string; appointmentId?: string }) => void;
};
export const CalendarCommands = (CalendarStore: CalendarStore): CalendarCommandsType => {
  const onEventContentClick = async (event: ClientTimeSlot) => {
    // console.log("Event content clicked", event);
    const patientId = event?.patient?.id;
    const patientLastName = event?.patient?.lastName;
    // console.debug("onEventContentClick", { patientId, patientLastName, event, rxId: event.rx?.id || "nada" });

    if (patientId) {
      // Set the target patient ID (convert to number if needed)
      runInAction(() => {
        const patientIdNumber = typeof patientId === 'string' ? parseInt(patientId, 10) : patientId;
        CalendarStore.setSelectedPatientId(patientIdNumber);
        if (patientLastName) {
          CalendarStore.setSelectedPatientLastName(patientLastName);
        }
        // Set the selected RX information
        CalendarStore.setSelectedRxId(event.rx?.id || undefined);

        // set sales if of that type:
        if (event.type == "SalesTimeSlot") {
          CalendarStore.setServiceSelected(true);
        }

        // Open the patient drawer
        CalendarStore.setPatientDrawerOpen(true);

      });
    }
  };

  /**
   * Generic navigation helper INTO the calendar route.
   * You can optionally supply date/patientId/patientLastName/rxId/appointmentId selections.
   */
  const navigateToCalendar = (
    navigate: NavigateFunction,
    opts?: { date?: string; patientId?: number; patientLastName?: string; rxId?: string; appointmentId?: string }
  ) => {
    const patch: any = {};
    if (opts?.date) patch.selectedDateStr = opts.date;
    if (opts?.patientId) {
      // Set both target and selected patient with same values
      patch.targetPatientId = opts.patientId;
      patch.selectedPatientId = opts.patientId;
      patch.patientDrawerOpen = true; // Open drawer if navigating with patient context
    }
    if (opts?.patientLastName) {
      // Set both target and selected patient last names
      patch.targetPatientLastName = opts.patientLastName;
      patch.selectedPatientLastName = opts.patientLastName;
    }
    if (opts?.rxId) patch.selectedRxId = opts.rxId;
    if (opts?.appointmentId) patch.targetAppointmentId = opts.appointmentId;
    navigateWithProjection(CalendarStore, navigate, {
      ctor: CalendarStore.constructor,
      patch,
    });
  };

  // Return the commands object
  return {
    onEventContentClick,
    navigateToCalendar,
  };
};
